<app-select-category
  [_control]="_control"
  [getCategories]="getCategories()"
  [saveCategory]="saveCategory()"
  [updateCategory]="updateCategory()"
  [deleteCategory]="deleteCategory()"
  [manualLoad]="manualLoad"
  [categoryList]="categoryList"
></app-select-category>
